var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverlay3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.660156 20C0.660156 8.9543 9.61446 0 20.6602 0H60.6502C71.6959 0 80.6502 8.95431 80.6502 20V59.99C80.6502 71.0357 71.6958 79.99 60.6502 79.99H20.6602C9.61446 79.99 0.660156 71.0357 0.660156 59.99V20Z",
    fill: "url(#paint0_linear_193_198)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9819 38.5094L24.6475 35.3888L40.6507 26.0536L56.6539 35.3888V46.7244H53.9867V36.9358L51.3195 38.5094V47.4179L51.0261 47.7646C49.7814 49.3116 48.27 50.5207 46.4918 51.392C44.6604 52.2811 42.7133 52.7256 40.6507 52.7256C38.588 52.7256 36.641 52.2811 34.8095 51.392C33.0314 50.5207 31.5199 49.3116 30.2753 47.7646L29.9819 47.4179V38.5094ZM32.6491 40.0564V46.4577C33.6448 47.5779 34.8273 48.4492 36.1964 49.0715C37.6012 49.7294 39.0859 50.0584 40.6507 50.0584C42.2154 50.0584 43.7002 49.7294 45.1049 49.0715C46.474 48.4492 47.6565 47.5779 48.6523 46.4577V40.0564L40.6507 44.724L32.6491 40.0564ZM29.9285 35.3888L40.6507 41.63L51.3728 35.3888L40.6507 29.1475L29.9285 35.3888Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_198",
    x1: 0.660156,
    y1: 0,
    x2: 80.6502,
    y2: 79.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9333EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay3);
export default __webpack_public_path__ + "static/media/Overlay-3.27194c5462bf8fbd5d14783749a06b8e.svg";
export { ForwardRef as ReactComponent };